import React from 'react'
import parse from 'html-react-parser'
import * as moment from 'moment'
import { Link } from 'gatsby'
var dateFormat = require('dateformat');

import Layout from '../components/layout'
import FeaturedNews from '../components/featuredNews'
import { Parallax } from 'react-parallax';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import IndexSplashXL from '../../static/img/index-splash-xl.jpg'
import StudentSandboxXL from '../../static/img/student-sandbox-bg-xl.jpg'
import StudentSandboxLG from '../../static/img/student-sandbox-bg-lg.jpg'
import StudentSandboxMD from '../../static/img/student-sandbox-bg-md.jpg'
import StudentSandboxSM from '../../static/img/student-sandbox-bg-sm.jpg'
import Sandbox from '../../static/img/sandbox-min.png'
import Sandbox2x from '../../static/img/sandbox@2x-min.png'
import Sandbox3x from '../../static/img/sandbox@3x-min.png'
//import WelcomeVideo from '../../static/img/welcome-video.png'
import WelcomeVideo from '../../static/img/rice-university-anne-charles-duncan-hall-1.jpg'
import ResearchEmphasisSplash from '../../static/img/research-emphasis-splash.jpg'
import REIcon1 from '../../static/img/re-icon-1.svg'
import REIcon2 from '../../static/img/re-icon-2.svg'
import REIcon3 from '../../static/img/re-icon-3.svg'
import REIcon4 from '../../static/img/re-icon-4.svg'
import REIcon5 from '../../static/img/re-icon-5.svg'
import REIcon6 from '../../static/img/re-icon-6.svg'
import Student from '../../static/img/student.jpg'
import NewsEvents1 from '../../static/img/news-events-1.jpg'
import NewsEvents2 from '../../static/img/news-events-2.jpg'
import NewsEvents3 from '../../static/img/news-events-3.jpg'
import LogoDark1x from '../../static/img/co-fes-logo-dark.png'
import LogoDark2x from '../../static/img/co-fes-logo-dark@2x.png'
import LogoDark3x from '../../static/img/co-fes-logo-dark@3x.png'
import RiceLogo1x from '../../static/img/rice-logo-footer.jpg'
import RiceLogo2x from '../../static/img/rice-logo-footer@2x.jpg'
import RiceLogo3x from '../../static/img/rice-logo-footer@3x.jpg'

const styles = { height: 612, width: "100%" };
const IconStyles = { width: '90px', height: '90px', objectFit: 'contain' };

class IndexPage extends React.Component {
     constructor(props) {
          super(props);
          console.log(props.data.homepageContent);
          this.state = {
               autoplay: true,
               content:props.data.homepageContent
          };
     }
     onSelect = (active, direction) => {

     };
     visiableOnSelect = active => {

     };
     slideNext = () => {
          this.slider.slideNext();
     };
     slidePrev = () => {
          this.slider.slidePrev();
     };
     goToSlide = () => {
          this.slider.goToSlide(4);
     };
     autoplay = () => {
          this.setState({ autoplay: !this.state.autoplay });
     };
     _changeIcon = () => {
          let { leftIcon, rightIcon } = this.state;
          leftIcon = leftIcon ? undefined : <span className="fa fa-glass" />;
          rightIcon = rightIcon ? undefined : <span className="fa fa-music" />;
          this.setState({ leftIcon, rightIcon });
     };
     render() {
          let unordered = {};
          let featured = [];
          let content = this.props.data.homepageContent;
          this.props.data.featuredNews.edges.forEach(function (item) {
               item.node.type = 'NEWS';
               item.node.date = new Date(item.node.date);
               let key = item.node.date.getTime();
               item.node.date = dateFormat(item.node.date, 'mediumDate');
               featured.push(item);
          });
          const featuredNews = featured.map(function (item, index) {
               return (
                    <FeaturedNews key={index} {...item.node}></FeaturedNews>
               );
          });
          return (
               <Layout className="index-page">
                     <div
                          className="splash jumbotron"
                          style={{ marginBottom: '0px', backgroundImage:`url(${IndexSplashXL})`, backgroundSize:'cover', backgroundPosition: 'bottom center' }}
                     >

                          <h2 className="text-white text-center wow fadeInDown">{parse(content.splash.title)}</h2>
                          <h3 className="text-white text-center wow fadeInRight">- {moment(content.splash.date).format('LL')} - </h3>
                          <p className="text-white text-center wow fadeInLeft">{parse(content.splash.subtitle)}</p>
                          <p className="text-white text-center wow fadeInUp"><a href={content.splash.button.link} className="btn btn-lg btn-primary pr-5 pl-5 pt-3 pb-3 rounded-0">{content.splash.button.text}</a></p>
                     </div>



                    <div className="container container-about">
                         <div className="row">
                              <div className="col-xl-8 col-lg-6 wow fadeInLeft">
                                   <h2><span>About Us</span></h2>
                                   <h1 className="text-primary">{parse(content.aboutSection.title)}</h1>
                                   <p>{parse(content.aboutSection.description)}</p>
                                   <div className="row">
                                        <div className="col-md-4"><a href={content.aboutSection.button.link} target='_blank' className="btn btn-sm btn-secondary rounded-0 pt-2 pb-2 pr-4 pl-4">{content.aboutSection.button.text}</a></div>
                                        <div className="col-md-8 text-secondary">{parse(content.aboutSection.blueText)}</div>
                                   </div>
                              </div>
                              <div className="col-xl-4 col-lg-6 wow fadeInRight">
                                   <h2 className="text-primary">Welcome</h2>
                                   <img src={WelcomeVideo} alt="Duncan Hall" />
                              </div>
                         </div>
                    </div>

                    <Parallax
                         bgImage={ResearchEmphasisSplash}
                         strength={-500}
                         className="jumbotron rounded research-emphasis"
                         style={{ paddingTop: '0px' }}
                    >
                         <div className="container">

                         </div>
                    </Parallax>
                    <div className="container container-membership">
                         <div className="row pt-4 pb-4">
                              <div className="col-xl-4 col-md-6 pt-4 pb-4 wow fadeInLeft">
                                   <img src={Student} alt="Student Membership" />
                              </div>
                              <div className="col-xl-8 col-md-6 pt-4 pb-4 wow fadeInRight">
                                   <h2 className="text-primary mt-4"><a href="/membership" target='_blank' className="text-primary mt-4">{parse(content.membershipSection.title)}</a></h2>
                                   {parse(content.membershipSection.description)}
                              </div>
                         </div>
                    </div>

                    <Parallax
                         bgImage={StudentSandboxXL}
                         strength={-200}
                         className="student-sandbox jumbotron"
                         style={{ paddingTop: '0px', marginBottom: '0px' }}
                         bgImageSizes={`(max-width: 400px) 400px,(max-width: 576px) 576px,(max-width: 768px) 768px,(max-width: 992px) 992px, 1200px`}
                         bgImageSrcSet={`${StudentSandboxSM} 400w,${StudentSandboxSM} 576w,${StudentSandboxMD} 768w,${StudentSandboxLG} 992w, ${StudentSandboxXL} 1200w`}
                    >
                         <div className="container">
                              <div className="row mt-4">
                                   <div className="col-lg-12 text-white text-center mt-4 mb-4">
                                        <h2>{parse(content.studentSection.title)}</h2>
                                        <p className="text-white text-center wow fadeInLeft">{parse(content.studentSection.subtitle)}</p>
                                        <p className="text-center mt-4 mb-4 wow fadeInRight"><img src={Sandbox} srcSet={`${Sandbox2x} 2x, ${Sandbox3x} 3x`} alt="Sample Sandbox"/></p>
                                        <p className="text-white text-center wow fadeInUp"><a href={content.studentSection.button.link} className="btn btn-lg btn-secondary pr-5 pl-5 pt-3 pb-3 rounded-0">{content.studentSection.button.text}</a></p>
                                   </div>
                              </div>
                         </div>

                    </Parallax>

                    <div className="container-fluid container-news pt-4 pb-4">
                         <div className="container">
                              <div className="row">
                                   <div className="col-xl-12 wow fadeInLeft">
                                        <h2><a href="/news-events" target="_blank" className="home_news_title">News <FontAwesomeIcon icon="angle-right"></FontAwesomeIcon></a></h2>
                                   </div>
                              </div>
                              <div className="row wow fadeInDown">
                                   {featuredNews}
                              </div>
                         </div>
                    </div>


               </Layout>
          );
     }
}

export default IndexPage;;
export const query = graphql`
     query FeaturedNews {
       featuredNews: allFlamelinkNewsContent(sort:{fields:[date],order:DESC},limit:3) {
         edges {
           node {
             id,
             title,
             shortDescription,
             details,
             thumbnail {
               contentType
               file
               folderId
               type
               url
               flamelink_id
             },
             date
           }
         }
    },
    homepageContent: flamelinkHomepageContent{
        splash{
          title,
          date,
          subtitle,
          button{
            text,
            link
          }
        }
        aboutSection{
          title,
          description
          button{text,link},
          blueText
        },
        membershipSection{
          title,
          description
        },
        studentSection{
          title,
          subtitle,
          button{text,link}
        }

    }
}
`;
